"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.referralPurchaseDetail = referralPurchaseDetail;
exports.referralPurchaseEdit = referralPurchaseEdit;
exports.referralPurchasePage = referralPurchasePage;
exports.referralPurchaseSave = referralPurchaseSave;
exports.toggleReferralStatus = toggleReferralStatus;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var querestUrl = '/xyGoodsActivityReferral';
// 编辑
function referralPurchaseEdit(data) {
  return (0, _requestPIM.default)({
    url: querestUrl,
    method: 'put',
    data: data
  });
}

// 推荐购保存
function referralPurchaseSave(data) {
  return (0, _requestPIM.default)({
    url: querestUrl,
    method: 'post',
    data: data
  });
}

// 推荐购分页
function referralPurchasePage(query) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/page',
    method: 'get',
    params: query
  });
}

// 推荐购详情
function referralPurchaseDetail(id) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/' + id,
    method: 'get'
  });
}

// 切换推荐购活动状态
function toggleReferralStatus(referralId, markForEnable) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/toggleStatus',
    method: 'post',
    data: {
      referralId: referralId,
      markForEnable: markForEnable
    }
  });
}